import BaseModelIssuance from "@/models/BaseModelIssuance.js";

export const GridConfig = {
	list: BaseModelIssuance.list,
	columns: BaseModelIssuance.columns,
	query: {
		batchQuery:true,
        filter : function(o){
            return o.BusinessEvent=='Issuance' && (o.WorkflowStatus == 'Approved' || o.WorkflowStatus == 'Correction Pending' || o.WorkflowStatus == 'Correction Approved')&& (o.ReceiverId != 1)
        },
		limit: 5000
	},
	grid: {
		gridId:'issuanceReportGrid',
		height: 500,
		checkbox: true,
		erase:false,
		document: true,	
		groupable: true,
		actionsColumnWidth:60
	},
}

export const ToolBarConfig = {
	items: [                
			{
					template: '<Label>From :</Label><input id="ProgramdatePickerFromDate" />', 
					overflow: "never"
			},
			{
					template: '<Label>To :</Label><input id="ProgramdatePickerToDate" />', 
					overflow: "never"
			},
			{
				id: "btnBulkAttachment",
				type: "button",
				text: "Attach Documents",
				showIcon: "toolbar",
				icon: "attachment",
				attributes: {
					"class": "float-right-btn btn btn-primary"
				}
			}
	]
}